
export const formatJoeditData = (data) => {
    return (
        <div dangerouslySetInnerHTML={{ __html: data }} />
    )
  };
  
  
  